<template>
	<div class="wrapper">
		<el-row :gutter="24">
			<el-col :span="24" style="position: relative;">
				<el-page-header style="background-color: #FFFFFF00;" @back="goBack" :content="meetingName">
				</el-page-header>
				<div class="flex align-center justify-between"
					style="padding: 15px 0px;background-color: #FFFFFF;margin-bottom: 10px;">
					<div class="text-center" style="width: 25%;">
						<div class="top_title">
							案号
						</div>
						<div class="top_content">
							{{meetingDataItem.subject}}
						</div>
					</div>
					<div class="text-center"
						style="width: 25%;border-left: 1px solid rgba(166,166,166,0.16);border-right: 1px solid rgba(166,166,166,0.16);">
						<div class="top_title">
							会议名称
						</div>
						<div class="top_content">
							{{meetingDataItem.name}}
						</div>
					</div>
					<div class="text-center" style="width: 25%;border-right: 1px solid rgba(166,166,166,0.16);">
						<div class="top_title">
							会议时间
						</div>
						<div class="top_content">
							{{ timeFormat(meetingDataItem.startTime) }}
						</div>
					</div>
					<div class="text-center" style="width: 25%;">
						<div class="top_title">
							会议地点
						</div>
						<div class="top_content">
							破产云网络会议
						</div>
					</div>
				</div>
				<!-- <el-table :data="[meetingData]" border>
					<el-table-column prop="subject" label="案号" align="center"> </el-table-column>
					<el-table-column prop="name" label="会议名称" align="center"> </el-table-column>
					<el-table-column prop="startTime" label="会议时间" align="center">
						<template slot-scope="scope">
							{{ timeFormat(scope.row.startTime) }}
						</template>
					</el-table-column>
					<el-table-column label="会议地点" align="center">
						<template>网络会议参会平台</template>
					</el-table-column>
				</el-table> -->
				<!-- <el-card class="meeting-document"> -->
				<el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
					<el-tab-pane label="会议文档" name="first" class="meetingFile">
						<div class="meeting-header-download" style="margin-bottom: 15px;">
							<!-- <a src="javascript:;" v-if="!isBtnShow" @click="uploadMeetingFile('video')" style="margin-right:20px"
				                                >上传视频>>></a
				                            > -->
							<div class="flex justify-end">
								<el-button v-if="userInfo.type != 'MANAGER'" icon="el-icon-daoru"
									@click="uploadMeetingFile">上传文档</el-button>
							</div>
							<!-- <a src="javascript:;" v-if="userInfo.type != 'MANAGER'"
								@click="uploadMeetingFile">上传文档>>></a> -->
						</div>
						<!--   <el-tabs v-model="fileActiveName" @tab-click="handleFileClick">
				                            <el-tab-pane label="会议文件" name="first"></el-tab-pane>
				                            <el-tab-pane label="视频文件" name="second"></el-tab-pane>
				                        </el-tabs> -->
						<el-table v-loading="loading" :data="meetingVoteData" size="medium" height="53.1vh">
							<el-table-column type="index" label="序号" align="center" width="100px"> </el-table-column>
							<!-- <el-table-column prop="ord" label="排序" align="center" width="80"> </el-table-column> -->
							<el-table-column min-width="100" prop="name" label="会议文档标题" align="center">
								<template slot-scope="scope">{{ scope.row.name || '无' }}</template>
							</el-table-column>
							<el-table-column width="200px" label="操作" align="center">
								<template slot-scope="scope">
									<el-button class="operation" size="medium" type="text" @click="sort(scope, 'up')">
										排序上升
									</el-button>
									<el-button class="operation" size="medium" type="text" @click="sort(scope, 'down')">
										排序下降</el-button>
									<!-- <el-button class="operation" size="mini" type="text" @click="editSort(scope.row)">编辑排序</el-button> -->
									<!-- v-if="userInfo.type != 'MANAGER'" -->
									<el-tooltip class="item" effect="dark" content="下载" placement="top">
										<div class="el-icon-xiazai"
											style="color: #0054FE;font-size: 16px;margin: 0px 10px;"
											@click="downloadFile(scope.row.docId, scope.row.name)">

										</div>
										<!-- <a class="el-icon-xiazai" :href="'/api/sys/fs/'+scope.row.docId+'?id=1'" :download="scope.row.name"></a> -->
									</el-tooltip>

									<!-- <el-button class="operation" size="mini" type="text"
										@click="downloadFile(scope.row.docId, scope.row.name)">下载</el-button> -->
									<el-tooltip v-if="userInfo.type != 'MANAGER'" class="item" effect="dark"
										content="删除" placement="top">
										<el-popconfirm title="确认删除该文件吗？" confirm-button-type="text"
											@confirm="() => deleteFile(scope.row.id || scope.row.docId)">
											<div slot="reference" class="el-icon-shanchu1"
												style="color: #0054FE;font-size: 14px;cursor: pointer;">

											</div>
											<!-- <el-button v-if="userInfo.type != 'MANAGER'" slot="reference" class="operation"
													style="margin-left: 10px" size="mini" type="text">删除
												</el-button> -->
										</el-popconfirm>
									</el-tooltip>

								</template>
							</el-table-column>
						</el-table>
						<Pagination v-if="fileActiveName === 'first'" :total="total" customClass="alone"
							@handleSizeChange="filePage" @handleCurrentChange="filePage" />
					</el-tab-pane>
					<el-tab-pane label="表决管理" name="second">
						<div class="voting-managent">
							<el-tabs v-model="subActiveName" @tab-click="handleSubClick">

								<el-tab-pane label="表决事项" name="second-first">
									<!-- style="background: #de4d2a !important" -->
									<div class="flex justify-end">

										<el-button
											v-if="isBtnShow && userInfo.type != 'MANAGER'&&meetingDataItem.state!='ENDED'"
											style="margin-bottom: 15px;" icon="el-icon-tianjia-" class="import "
											@click="addVote">新建表决
										</el-button>
									</div>
									<el-table v-loading="loading" :data="meetingVoteData" size="medium"
										:height="userInfo.type != 'MANAGER'&&meetingDataItem.state!='ENDED'?'47.8vh':'52.8vh'">
										<el-table-column prop="serialNumber" label="序号" align="center" width="100px">
										</el-table-column>
										<el-table-column prop="name" label="表决事项" align="center" min-width="300px">
											<template slot-scope="scope">{{ scope.row.name || '无' }}</template>
										</el-table-column>
										<el-table-column min-width="300px" prop="allowPartVote" label="是否允许多笔债权分别投票"
											align="center">
											<template slot-scope="scope">
												{{ scope.row.allowPartVote ? '是' : '否' }}
											</template>
										</el-table-column>
										<el-table-column min-width="230px" prop="showProportion" label="是否显示占比"
											align="center">
											<template slot-scope="scope">
												{{ scope.row.showProportion ? '是' : '否' }}
											</template>
										</el-table-column>
										<el-table-column min-width="230px" label="是否有弃权项" align="center">
											<template slot-scope="scope">
												{{ scope.row.allowWaive ? '是' : '否' }}
											</template>
										</el-table-column>
										<el-table-column min-width="230px" label="表决状态" align="center">
											<template slot-scope="scope">
												{{ getStatus(scope.row) }}
											</template>
										</el-table-column>
										<el-table-column fixed="right" width="250px" label="操作" align="center">
											<template slot-scope="scope">
												<el-popconfirm title="确认开始表决吗？" confirm-button-type="text"
													@confirm="operationVote('begin', scope.row.id)"
													@onConfirm="operationVote('begin', scope.row.id)">
													<el-button style="margin: 0px 10px;" slot="reference"
														v-if="!scope.row.began && meetingData[0].began && userInfo.type != 'MANAGER'"
														size="medium" type="text" class="operation">开始表决</el-button>
												</el-popconfirm>
												<!-- <el-button size="medium"
													v-if="!scope.row.began && meetingData[0].began && userInfo.type != 'MANAGER'"
													type="text" class="operation" style="margin: 0px 10px;"
													@click="operationVote('begin', scope.row.id)">开始表决</el-button> -->
												<el-popconfirm title="确认结束表决吗？" confirm-button-type="text"
													@confirm="operationVote('end', scope.row.id)"
													@onConfirm="operationVote('end', scope.row.id)">
													<el-button style="margin: 0px 10px;" slot="reference"
														v-if="scope.row.began && !scope.row.ended && userInfo.type != 'MANAGER'"
														size="medium" type="text" class="operation">结束表决</el-button>
												</el-popconfirm>

												<el-button size="medium" type="text" class="operation"
													@click="VoteResult(scope.row)">表决详情</el-button>

												<!-- 编辑所有内容 -->
												<el-tooltip v-if="!scope.row.ended && userInfo.type != 'MANAGER'"
													class="item" effect="dark" content="编辑" placement="top">
													<el-button icon="el-icon-bianji" size="medium" type="text"
														v-if="!scope.row.ended && userInfo.type != 'MANAGER'"
														class="operation"
														@click="!scope.row.began ? editVote(scope.row) : editVote(scope.row, false)">
														<!-- 编辑表决 -->
													</el-button>
												</el-tooltip>
												<el-tooltip v-if="scope.row.ended && userInfo.type != 'MANAGER'"
													class="item" effect="dark" content="重开表决" placement="top">
													<el-button icon="el-icon-zhongzhishaixuan" size="medium" type="text"
														v-if="scope.row.ended && userInfo.type != 'MANAGER'"
														class="operation"
														@click="voteRestart(scope.row.id)">
														<!-- 编辑表决 -->
													</el-button>
												</el-tooltip>
											</template>
										</el-table-column>
									</el-table>
									<Pagination :total="total" customClass="alone" @handleSizeChange="voteListPage"
										@handleCurrentChange="voteListPage" />
								</el-tab-pane>
								<el-tab-pane label="表决分组" name="second-second">
									<div class="importFile">
										<Progress :isShow="isShow" :percentage="percentage" />
										<div v-if="!isShow"></div>
										<!-- style="background: #de4d2a !important" -->

										<div class="flex justify-end" style="margin-bottom: 15px;">
											<!--  -->
											<!-- style="border: 1px solid #9BA2AB;color: #282D30;" size="mini" -->
											<el-button @click="votingGroupingClick" style="margin-right: 10px;"
												icon="el-icon-notebook-2">详情</el-button>
											<el-button v-if="isBtnShow && userInfo.type != 'MANAGER'" class="import"
												icon="el-icon-daoru" @click="
											    uploadDialogVisible = true;
											isAccept = false;
											isFileCheck = false;
											isVideo = false;
											                                            ">导入</el-button>
										</div>

									</div>
									<el-table v-loading="loading" :data="meetingVoteDatas" size="medium"
										:height="userInfo.type != 'MANAGER'?'55.4vh':'58.8vh'">
										<el-table-column prop="serialNumber" label="序号" align="center" width="100px">
										</el-table-column>
										<el-table-column prop="groupName" label="债权类型" align="center">
											<template slot-scope="scope">{{ scope.row.groupName || '无' }}</template>
										</el-table-column>
										<el-table-column prop="count" label="人员数量" align="center">
											<template slot-scope="scope">{{ scope.row.count || '无' }}</template>
										</el-table-column>
										<el-table-column prop="amountTotal" label="债权总额" align="center">
											<template
												slot-scope="scope">{{ '￥'+ scope.row.amountTotal? $formatAmount(scope.row.amountTotal):scope.row.amountTotal || '无' }}</template>
										</el-table-column>
										<el-table-column v-if="userInfo.type != 'MANAGER'" label="操作" align="center">
											<template slot-scope="scope">
												<el-tooltip v-if="userInfo.type != 'MANAGER'" class="item" effect="dark"
													content="删除" placement="top">
													<el-popconfirm title="确认删除该表决分组吗？" confirm-button-type="text"
														@confirm="deleteGroup(scope.row.groupId)"
														@onConfirm="deleteGroup(scope.row.groupId)">
														<div slot="reference" class="el-icon-shanchu1"
															style="color: #0054FE;font-size: 18px;">

														</div>
														<!-- <el-button icon="el-icon-shanchu1" v-if="userInfo.type != 'MANAGER'" slot="reference"
															class="operation" size="16px"
															type="text"></el-button> -->
													</el-popconfirm>
												</el-tooltip>

											</template>
										</el-table-column>
									</el-table>
								</el-tab-pane>
								<el-tab-pane label="表决人员详情" name="second-third">
									<div class="votestaff-search">
										<el-form :inline="true" :model="voteDetailForm" class="demo-form-inline">
											<el-form-item>
												<el-input v-model.trim="voteDetailForm.keyword" clearable
													placeholder="请输入关键字"></el-input>
											</el-form-item>
											<el-form-item>
												<el-select v-model="voteDetailForm.test" placeholder="是否测试" clearable>
													<el-option label="全部" value="0"></el-option>
													<el-option label="已测试" :value="true"></el-option>
													<el-option label="未测试" :value="false"></el-option>
												</el-select>
											</el-form-item>
											<el-form-item>
												<el-select v-model="voteDetailForm.sign" placeholder="是否会议签到" clearable>
													<el-option label="全部" value="0"></el-option>
													<el-option label="已签到" :value="true"></el-option>
													<el-option label="未签到" :value="false"></el-option>
												</el-select>
											</el-form-item>
											<el-form-item>
												<el-select v-model="voteDetailForm.group_id" placeholder="类型/组别"
													clearable>
													<el-option v-for="item in groupData" :key="item.id"
														:label="item.name" :value="item.id"></el-option>
												</el-select>
											</el-form-item>
											<el-form-item class="meeting-search-button">
												<!-- style="background: #de4d2a !important" -->
												<el-button icon="el-icon-search" type="primary"
													@click="onSearch('voteDetailForm')">查询
												</el-button>
											</el-form-item>
											<div class="" style="float: right;">

												<el-form-item class="">
													<div class="flex justify-end">
														<!-- v-if="isBtnShow && userInfo.type != 'MANAGER'" -->
														<el-button icon="el-icon-daochu" @click="exportVoteSituation">
															人员详情导出
														</el-button>
														<!-- <el-button style="border: 1px solid #9BA2AB;color: #282D30;"
															class="import" icon="el-icon-daochu"
															@click="exportVoteSituation">人员详情导出</el-button> -->
													</div>

													<!-- <el-tooltip class="item" effect="dark" content="表决人员详情导出"
														placement="top">
														<i class="iconfont icon-daochu"
															@click="exportVoteSituation"></i>
													</el-tooltip> -->

												</el-form-item>
											</div>

										</el-form>
									</div>
									<el-table :data="meetingVoteData" size="medium" height="47.3vh" v-loading="loading">
										<el-table-column width="50px" prop="serialNumber" label="序号" align="center">
										</el-table-column>
										<el-table-column min-width="150px" prop="name" label="债权人名称" align="center">
											<template slot-scope="scope">{{ scope.row.name || '无' }}</template>
										</el-table-column>
										<el-table-column min-width="170px" prop="idNumber" label="债权人证件号"
											align="center">
											<template slot-scope="scope">{{ scope.row.idNumber || '无' }}</template>
										</el-table-column>
										<el-table-column min-width="150px" prop="phone" label="债权人手机号" align="center">
											<template slot-scope="scope">{{ scope.row.phone || '无' }}</template>
										</el-table-column>
										<el-table-column min-width="150px" prop="agentName" label="代理人名称"
											align="center">
											<template slot-scope="scope">{{ scope.row.agentName || '无' }}</template>
										</el-table-column>
										<el-table-column min-width="170px" prop="agentIdNumber" label="代理人证件号"
											align="center">
											<template slot-scope="scope">{{ scope.row.agentIdNumber || '无' }}</template>
										</el-table-column>
										<el-table-column min-width="150px" prop="agentPhone" label="代理人手机号"
											align="center">
											<template slot-scope="scope">{{ scope.row.agentPhone || '无' }}</template>
										</el-table-column>
										<el-table-column min-width="150px" prop="amount" label="金额(元)" align="center">
											<template slot-scope="scope">{{ scope.row.amount?$formatAmount(scope.row.amount):scope.row.amount }}</template>
										</el-table-column>
										<el-table-column min-width="150px" prop="groupName" label="类型/组别"
											align="center">
											<template slot-scope="scope">{{ scope.row.groupName || '无' }}</template>
										</el-table-column>
										<el-table-column min-width="120px" prop="test" label="是否测试" align="center">
											<template slot-scope="scope">
												{{ scope.row.test ? '已测试' : '未测试' }}
											</template>
										</el-table-column>
										<el-table-column min-width="120px" prop="sign" label="是否签到" align="center">
											<template slot-scope="scope">
												{{ scope.row.sign ? '已签到' : '未签到' }}
											</template>
										</el-table-column>
										<el-table-column min-width="160px" label="签到时间" align="center">
											<template slot-scope="scope">
												{{ scope.row.signTime ? timeFormat(scope.row.signTime) : '暂无' }}
											</template>
										</el-table-column>

									</el-table>
									<Pagination :total="total" customClass="alone" @handleSizeChange="turnPage"
										@handleCurrentChange="turnPage">
										<!-- <template v-slot:operation>
											
										</template> -->
									</Pagination>
								</el-tab-pane>
							</el-tabs>
						</div>
					</el-tab-pane>
					<el-tab-pane label="会议情况" name="third">
						<div class="meeting-search">
							<el-form :inline="true" :model="userForm" class="demo-form-inline">
								<el-form-item>
									<el-input style="width: 270px;" v-model.trim="userForm.keyword" clearable
										placeholder="请输入关键字">
									</el-input>
								</el-form-item>
								<el-form-item>
									<el-select style="width: 270px;" v-model="userForm.test" placeholder="是否测试"
										clearable>
										<el-option label="全部" value="0"></el-option>
										<el-option label="已测试" :value="true"></el-option>
										<el-option label="未测试" :value="false"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item>
									<el-select style="width: 270px;" v-model="userForm.sign" placeholder="是否会议签到"
										clearable>
										<el-option label="全部" value="0"></el-option>
										<el-option label="已签到" :value="true"></el-option>
										<el-option label="未签到" :value="false"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item class="meeting-search-button">
									<!-- style="background: #de4d2a !important" -->
									<el-button icon="el-icon-search" type="primary" @click="onSearch('userForm')">查询
									</el-button>
								</el-form-item>
								<div class="" style="float: right;">
									<el-form-item>
										<el-button icon="el-icon-daochu" @click="exportMeetingSituation">会议情况导出
										</el-button>
										<!-- <el-tooltip class="item" effect="dark" content="会议情况导出" placement="top">
										<i class="el-icon-daochu" @click="exportMeetingSituation"></i>
									</el-tooltip> -->
									</el-form-item>
								</div>

							</el-form>
							<div class="flex align-center"
								style="width: 100%;padding: 15px;font-size: 14px;color: #000000;position: relative;">
								<div class="flex align-center">
									<div class="" style="color: #74798C;">
										已测试：
									</div>
									<div class="" style="font-weight: bold;">
										{{ attendSituation.testedCount }}人(占比为{{
										                        keepTwoDecimalFull(attendSituation.testedRate * 100) + '%'
										                }})
									</div>
								</div>
								<div class="flex align-center" style="margin: 0px 50px;">
									<div class="" style="color: #74798C;">
										未测试：
									</div>
									<div class="" style="font-weight: bold;">
										{{ attendSituation.notTestedCount }}人(占比为{{
										                        keepTwoDecimalFull(attendSituation.notTestedRate * 100) + '%'
										                }})
									</div>
								</div>
								<div class="flex align-center">
									<div class="" style="color: #74798C;">
										已签到：
									</div>
									<div class="" style="font-weight: bold;">
										{{ attendSituation.signedCount }}人(占比为{{
										                        keepTwoDecimalFull(attendSituation.signedRate * 100) + '%'
										                }})
									</div>
								</div>
								<div class="flex align-center" style="margin: 0px 50px;">
									<div class="" style="color: #74798C;">
										未参会：
									</div>
									<div class="" style="font-weight: bold;">
										{{ attendSituation.notSignedCount }}人(占比为{{
										                        keepTwoDecimalFull(attendSituation.notSignedRate * 100) + '%'
										                }})
									</div>
								</div>
								<div v-if="meetingInfo.normalSign" class="" style="position: absolute;right: 40px;">
									<el-button icon="el-icon-download" @click="signedInstrumentDownload">
										签署文件下载
									</el-button>
								</div>
							</div>

							<!-- <div class="situation">
								<p>
									已测试 {{ attendSituation.testedCount }}人(占比为{{
				                                            keepTwoDecimalFull(attendSituation.testedRate * 100) + '%'
				                                    }}),
								</p>
								<p>
									未测试 {{ attendSituation.notTestedCount }}人(占比为{{
				                                            keepTwoDecimalFull(attendSituation.notTestedRate * 100) + '%'
				                                    }}),
								</p>
								<p>
									已签到 {{ attendSituation.signedCount }}人(占比为{{
				                                            keepTwoDecimalFull(attendSituation.signedRate * 100) + '%'
				                                    }}),
								</p>
								<p>
									未参会 {{ attendSituation.notSignedCount }}人(占比为{{
				                                            keepTwoDecimalFull(attendSituation.notSignedRate * 100) + '%'
				                                    }}),
								</p>
							</div> -->
						</div>
						<el-table :data="meetingVoteData" size="medium" v-loading="loading" height="47.4vh">
							<el-table-column prop="serialNumber" label="序号" align="center" width="50px">
							</el-table-column>
							<el-table-column min-width="200px" prop="name" label="债权人姓名" align="center">
								<template slot-scope="scope">{{ scope.row.name || '无' }}</template>
							</el-table-column>
							<el-table-column min-width="150px" prop="phone" label="债权人手机号" align="center">
								<template slot-scope="scope">{{ scope.row.phone || '无' }}</template>
							</el-table-column>
							<el-table-column min-width="170px" prop="idNumber" label="债权人证件号码" align="center">
								<template slot-scope="scope">{{ scope.row.idNumber || '无' }}</template>
							</el-table-column>
							<el-table-column min-width="150px" prop="agentName" label="代理人姓名" align="center">
								<template slot-scope="scope">{{ scope.row.agentName || '无' }}</template>
							</el-table-column>
							<el-table-column min-width="150px" prop="agentPhone" label="代理人手机号" align="center">
								<template slot-scope="scope">{{ scope.row.agentPhone || '无' }}</template>
							</el-table-column>
							<el-table-column min-width="170px" prop="agentIdNumber" label="代理人证件号码" align="center">
								<template slot-scope="scope">{{ scope.row.agentIdNumber || '无' }}</template>
							</el-table-column>
							<el-table-column min-width="150px" label="是否测试" align="center">
								<template slot-scope="scope">
									{{ scope.row.test ? '已测试' : '未测试' }}
								</template>
							</el-table-column>
							<el-table-column min-width="150px" label="会议签到" align="center">
								<template slot-scope="scope">
									{{ scope.row.sign ? '已签到' : '未签到' }}
								</template>
							</el-table-column>
							<el-table-column min-width="150px" prop="signTime" label="会议签到时间" align="center">
								<template slot-scope="scope">
									{{ scope.row.signTime ? timeFormat(scope.row.signTime) : '暂无' }}
								</template>
							</el-table-column>
							<!-- v-if="meetingInfo && meetingInfo.signature" -->
							<template v-if="meetingInfo && meetingInfo.signature">
								<el-table-column fixed="right" v-if="userInfo.type != 'MANAGER'" min-width="100"
									prop="signTime" label="实名认证" align="center">
									<template slot-scope="scope">
										<el-button size="medium" type="text"
											:disabled="!scope.row.agentMeetingAuth && !scope.row.meetingAuth"
											@click="tapShowDetails(scope.row)">详情</el-button>
									</template>
								</el-table-column>
							</template>
						</el-table>
						<Pagination :total="total" customClass="alone" @handleSizeChange="userPage"
							@handleCurrentChange="userPage">
							<!-- <template v-slot:operation>
								
							</template> -->
						</Pagination>
					</el-tab-pane>
					<el-tab-pane label="提问列表" name="four">
						<div class="tag-question">
							<el-tabs v-model="tagQuestion" @tab-click="markSign">
								<el-tab-pane label="全部提问" name="second-first">

								</el-tab-pane>
								<el-tab-pane label="已标记提问" name="second-second">

								</el-tab-pane>
							</el-tabs>

							<!-- <el-radio-group v-model="tagQuestion" size="medium" @change="markSign">
								<el-radio-button label="全部提问" value="0"></el-radio-button>
								<el-radio-button label="已标记提问" value="1"></el-radio-button>
							</el-radio-group> -->
						</div>
						<div class="question-card meeting-search">
							<el-form :inline="true" :model="questionForm" class="demo-form-inline">
								<el-form-item>
									<el-input style="width: 400px;" v-model.trim="questionForm.keyword" clearable
										placeholder="关键词搜索">
									</el-input>
								</el-form-item>
								<el-form-item>
									<el-button icon="el-icon-search" type="primary" @click="onSearch('questionForm')">查询
									</el-button>
								</el-form-item>
								<div class="" style="float: right;">
									<el-form-item class="meeting-search-button">

										<div class="flex align-center" style="float: right;">
											<el-button icon="el-icon-daochu" @click="exportQuestionSituation">提问列表导出
											</el-button>
											<div v-if="isBtnShow && userInfo.type != 'MANAGER'"
												class="flex align-center">
												<div class=""
													style="font-size: 14px;font-weight: 400;color: #74798C;margin-right: 8px;margin-left: 28px;">
													开启提问
												</div>
												<el-switch :value="question" @change="changeQuestion">
												</el-switch>
											</div>
										</div>
									</el-form-item>
								</div>
							</el-form>

							<!-- <div>
								<el-input v-model="questionForm.keyword" clearable placeholder="关键词搜索...">
								</el-input>
								<el-button type="primary" @click="onSearch('questionForm')">查询</el-button>
							</div>
							<div v-if="isBtnShow && userInfo.type != 'MANAGER'">
								<el-button :type="question ? 'primary' : 'success'" @click="changeQuestion">{{
				                                        question ? '结束提问' : '开启提问'
				                                }}</el-button>
							</div> -->
						</div>
						<el-table :data="meetingVoteQuizData" size="medium" height="47.3vh">
							<el-table-column prop="serialNumber" label="序号" align="center" width="100px">
							</el-table-column>
							<el-table-column min-width="150px" prop="name" label="提问人" align="center">
								<template slot-scope="scope">{{ scope.row.name || '无' }}</template>
							</el-table-column>
							<el-table-column min-width="170px" prop="username" label="证件号" align="center">
								<template slot-scope="scope">{{ scope.row.idNumber || '无' }}</template>
							</el-table-column>
							<el-table-column min-width="350px" prop="content" label="提问内容" align="center">
								<template slot-scope="scope">{{ scope.row.content || '无' }}</template>
							</el-table-column>
							<el-table-column min-width="350px" prop="replyList" label="回复内容" align="center">
								<template slot-scope="scope">
									<div class="" v-for="(items,indexs) in scope.row.replyList" key="indexs">
										【{{indexs + 1}}】{{ items.content || '无' }}
									</div>
								</template>
							</el-table-column>
							<el-table-column min-width="150px" prop="createTime" label="提问时间" align="center">
								<template slot-scope="scope">
									{{ timeFormat(scope.row.createTime) }}
								</template>
							</el-table-column>
							<el-table-column min-width="150px" prop="mark" label="是否标记" align="center">
								<template slot-scope="scope">
									{{ scope.row.mark ? '是' : '否' }}
								</template>
							</el-table-column>
							<el-table-column fixed="right" width="150" label="操作" align="center">
								<template slot-scope="scope">
									<div class="flex align-center justify-center">
										<div class="flex align-center">
											<el-button size="medium"
												@click="replyShow(scope.row.meetingId,scope.row.id)" type="text"
												style="margin-right: 16px;">回复</el-button>
											<!-- <div class="" style="margin-right: 16px;">
												
												<el-popover
												    placement="left"
												    trigger="click"
													v-model="scope.row.visible"
													>
												   <div class="">
												   	<div class="" style="width: 240px;height: 96px;">
														<textarea style="width: 240px;height: 96px;max-height: 96px;max-width: 240px;resize:none;" placeholder="输入回复的内容" v-model="responseInput"></textarea>
														
												   	</div>
													<div class="flex align-center justify-center" style="margin-top: 10px;">
														<div class="flex align-center">
															<el-button @click="scope.row.visible = false">取消</el-button>
															<el-button type="primary" @click="submitReply(scope.row.meetingId,scope.row.id)">确认</el-button>
														</div>
													</div>
												   </div>
												   <el-button slot="reference" type="text">回复</el-button>
												  </el-popover>
											</div> -->

											<el-popconfirm :title="scope.row.mark ? '确定对该问题取消标记吗？' : '确定对该问题进行标记吗？'"
												@onConfirm="markQuestion(scope.row)">
												<el-button size="medium" slot="reference" class="mark-question"
													type="text">{{
											                            scope.row.mark ? '取消标记' : '标记'
											                    }}</el-button>
											</el-popconfirm>
										</div>
									</div>

								</template>
							</el-table-column>
						</el-table>
						<Pagination :total="total" customClass="alone" @handleSizeChange="questionPage"
							@handleCurrentChange="questionPage">
							<!-- <template v-slot:operation>
								<el-tooltip class="item" effect="dark" content="问题列表导出" placement="top">
									<i class="iconfont icon-daochu" @click="exportQuestionSituation"></i>
								</el-tooltip>
							</template> -->
						</Pagination>
					</el-tab-pane>
					<!-- 新的短信管理 -->
					<el-tab-pane v-if="userInfo.type == 'ADMIN' || userInfo.type == 'MANAGER' " label="短信管理"
						name="five">
						<SMSManagement :meetingData="meetingData" :meetingVoteData="meetingVoteDatas"
							:smsTemplateList="smsTemplateList" :isActiveName="isActiveName" :meetingId="meetingId" />
					</el-tab-pane>
					<!-- <el-tab-pane v-if="userInfo.type != 'MANAGER'" label="短信管理" name="five">
						<SmsTemplate :meetingData="meetingData" :smsTemplateList="smsTemplateList"
							:isActiveName="isActiveName" :meetingId="meetingId" />
					</el-tab-pane> -->
					<el-tab-pane v-if="userInfo.type == 'ADMIN' || userInfo.type == 'MANAGER' " label="语音管理" name="six">
						<VMSManagement :meetingData="meetingData" :vmsTemplateList="vmsTemplateList"
							:isActiveName="isVmsActiveName" :meetingId="meetingId" />
					</el-tab-pane>
					<!-- <el-tab-pane v-if="userInfo.type != 'MANAGER'" label="语音管理" name="six">
						<VmsTemplate :meetingData="meetingData" :vmsTemplateList="vmsTemplateList"
							:isActiveName="isVmsActiveName" :meetingId="meetingId" />
					</el-tab-pane> -->
					<el-tab-pane v-if="meetingDataItem.state =='ENDED'" label="会议存证" name="meetingRecord">
						<MeetingRecord :getMeetingRecordRes="getMeetingRecordRes" :name="meetingDataItem.name">
						</MeetingRecord>
					</el-tab-pane>
					<el-tab-pane label="人员管理" name="peopleManagement">
						<Creditor :peopleManagementActiveName="creditorActiveName" :meetingId="meetingId">
						</Creditor>
					</el-tab-pane>


				</el-tabs>
				<!-- </el-card> -->
				<span slot="footer" class="dialog-footer">
					<!-- style="background: #de4d2a !important" -->
					<el-button @click="cancelVisible" type="primary">关闭
					</el-button>
				</span>
				<!-- 回复 -->
				<el-dialog append-to-body top="25vh" :visible.sync="replyShowType" width="30%" :center="false"
					@close="replyClose">
					<!-- <el-input style="width: 100%;height: 96px;max-height: 96px;max-width: 100%;resize:none;" type="textarea" :rows="2" placeholder="请输入内容" v-model="responseInput"> -->
					<textarea style="width: 95%;height: 96px;max-height: 96px;max-width: 95%;resize:none;padding: 10px;"
						placeholder="输入回复的内容" v-model="responseInput"></textarea>
					</el-input>
					<div class="flex align-center justify-center" style="margin-top: 20px;">
						<span slot="footer" class="dialog-footer">
							<el-button @click="replyShowType = false">取 消</el-button>
							<!-- style="background: #de4d2a !important" -->
							<el-button type="primary" @click="submitReply()">确 定
							</el-button>
						</span>
					</div>
				</el-dialog>
				<!-- 编辑排序 -->
				<el-dialog append-to-body title="编辑排序" top="25vh" :visible.sync="sortDialogVisible" width="300px"
					center>
					<div style="text-align: center">
						<el-input-number v-model="sortOrd"></el-input-number>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button @click="sortDialogVisible = false">取 消</el-button>
						<!-- style="background: #de4d2a !important" -->
						<el-button type="primary" @click="sureSort">确 定
						</el-button>
					</span>
				</el-dialog>
				<!-- 导入分组错误弹出层 -->
				<el-dialog append-to-body title="提示" top="30vh" :visible.sync="importDialogVisible" width="460px"
					center>
					<div>
						<h3 class="person-error">以下用户不是该会议的债权人</h3>
						<p>
							{{ person }}
						</p>
					</div>
					<span slot="footer" class="dialog-footer">
						<!-- style="background: #de4d2a !important" -->
						<el-button type="primary" @click="importDialogVisible = false">关闭</el-button>
					</span>
				</el-dialog>
				<!-- 新建表决弹出层 -->
				<AddVote :voteForm="voteForm" :groupData="groupData" :voteDialogVisible="voteDialogVisible"
					:meetingId="meetingId" :isEdit="isEdit" :isFlag="isFlag" @cancel="cancel" @refresh="getVoteList"
					:switchDisabled="true" />
				<!-- 上传文件弹出层 -->
				<UploadFile :uploadDialogVisible="uploadDialogVisible" :isAccept="isAccept" :isFileCheck="isFileCheck"
					:isFlag="true" :isVideo="isVideo" @cancel="cancel" @sureUpload="sureUpload" />
				<!-- 表决详情弹出层 -->

				<VoteResult @cancel="cancel" :meetingData="meetingData" :voteLoading="voteLoading"
					:voteDetailList="voteDetailList" :voteDetail="voteDetail"
					:voteResultDialogVisible="voteResultDialogVisible" :userInfo="userInfo" />

				<!-- 表决详情弹出层 -->
				<VoteResults @cancel="cancels" :meetingData="meetingData" :voteLoading="voteLoadings"
					:voteDetailList="voteDetailLists" :voteDetail="voteDetails"
					:voteResultDialogVisible="voteResultDialogVisibles" />
				<!-- 详情-实名认证 -->
				<el-dialog append-to-body title="实名认证" :visible.sync="detailsVisible" width="460px" :center="false">

					<div v-if="form.meetingAuth.name&&form.meetingAuth.idCard" class=""
						style="position: relative;width: 430px;height: 177px;">
						<img style="width: 430px;height: 177px;" src="../../assets/img/background-Blue.png">
						<div class="flex align-center justify-center"
							style="position: absolute;top: 31px;width: 430px;">
							<div class="">
								<div class="flex align-center">
									<div class="details_name">
										债权人姓名
									</div>
									<div class="details_content">
										{{form.meetingAuth.name}}
									</div>

								</div>
								<div class="flex align-center" style="margin-top: 20px;">
									<div class="details_name">
										债权人身份证号
									</div>
									<div class="details_content_1">
										{{form.meetingAuth.idCard}}
									</div>
								</div>
								<div class="flex align-center justify-center" style="margin-top: 25px;">
									<!-- onDownLoad(form.signFileId) -->
									<el-button type="primary" v-if="form.signFileId" style="margin-top: 5px;"
										@click="downloadFile(form.signFileId)">下载文件
									</el-button>
								</div>

							</div>

						</div>
					</div>
					<div v-if="form.agentMeetingAuth.name&&form.agentMeetingAuth.idCard" class=""
						style="position: relative;width: 430px;height: 177px;"
						:style="form.meetingAuth.name&&form.meetingAuth.idCard&&form.agentMeetingAuth.name&&form.agentMeetingAuth.idCard?'margin-top: 20px;':''">
						<img style="width: 430px;height: 177px;" src="../../assets/img/background-yellow.png">
						<div class="flex align-center justify-center"
							style="position: absolute;top: 31px;width: 430px;">
							<div class="">
								<div class="flex align-center">
									<div class="details_name">
										代理人姓名
									</div>
									<div class="details_content">
										{{form.agentMeetingAuth.name}}
									</div>

								</div>
								<div class="flex align-center" style="margin-top: 20px;">
									<div class="details_name">
										代理人身份证号
									</div>
									<div class="details_content_1">
										{{form.agentMeetingAuth.idCard}}
									</div>
								</div>
								<div class="flex align-center justify-center" style="margin-top: 25px;">
									<!-- downloadFile(form.signFileId,'签字文件.pdf') -->
									<!-- onDownLoad(form.agentMeetingAuth.flowId) -->
									<el-button type="primary" v-if="form.signFileId" style="margin-top: 5px;"
										@click="downloadFile(form.signFileId)">下载文件
									</el-button>
								</div>

							</div>

						</div>
					</div>


					<!-- <el-form :model="form" status-icon label-width="120px" class="demo-ruleForm">
						<el-form-item label="债权人姓名" v-if="form.meetingAuth.name">
							<el-input type="text" readonly v-model="form.meetingAuth.name" autocomplete="off"
								placeholder="请输入案号">
							</el-input>
						</el-form-item>
						<el-form-item label="债权人身份证号" v-if="form.meetingAuth.idCard">
							<el-input type="text" readonly v-model="form.meetingAuth.idCard" autocomplete="off"
								:maxlength="50" placeholder="会议名称不能超过50个字符"></el-input>
							<el-button type="primary" v-if="form.meetingAuth.flowId" style="margin-top: 5px;"
								@click="onDownLoad(form.meetingAuth.flowId)">下载文件
							</el-button>
						</el-form-item>
						<el-form-item label="代理人姓名" v-if="form.agentMeetingAuth.name">
							<el-input type="text" readonly v-model="form.agentMeetingAuth.name" autocomplete="off"
								placeholder="请输入发起人">
							</el-input>
						</el-form-item>
						<el-form-item label="代理人身份证号" v-if="form.agentMeetingAuth.idCard">
							<el-input type="text" readonly v-model="form.agentMeetingAuth.idCard" autocomplete="off"
								placeholder="请输入发起人">
							</el-input>
							<el-button type="primary" v-if="form.agentMeetingAuth.flowId" style="margin-top: 5px;"
								@click="onDownLoad(form.agentMeetingAuth.flowId)">下载文件
							</el-button>
						</el-form-item>
					</el-form> -->
					<!-- <span slot="footer" class="dialog-footer">
						<el-button type="primary" @click="detailsVisible = false">关闭
						</el-button>
					</span> -->
				</el-dialog>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import moment from 'moment';
	import global from 'global';
	import Creditor from '../creditor';
	import AddVote from '../meetingManages/components/vote/addVote';
	import SmsTemplate from '../meetingManages/components/sms/smsTemplate';
	import SMSManagement from '../SMSManagement';
	import VMSManagement from '../VMSManagement';
	import VmsTemplate from '../meetingManages/components/sms/vmsTemplate';
	import VoteResult from '../meetingManages/components/vote/voteResult';
	import VoteResults from '../meetingManages/components/vote/voteResults';
	import MeetingRecord from '../meetingRecord/meetingRecord.vue';
	import bus from '@/utils/bus';
	import UploadFile from '@/components/uploadFile';
	import Progress from '@/components/progress';
	import Pagination from '@/components/Pagination';
	import {
		getSmsTemplate
	} from '@/serve/sms';
	import {
		getVmsTemplate
	} from '@/serve/vms';
	// import { getMeetingCount, getMeetingList } from '@/serve/meeting';
	import {
		mapState
	} from 'vuex';
	import {
		getCreatorCount,
		getCreatorUserList,
		meetingAuthGetFile
	} from '@/serve/user';
	import {
		getQuestionList,
		getQuestionCount,
		editQuestionStatus,
		markQuestion
	} from '@/serve/question';
	import {
		getMeetingDetail,
		getAttendSituation,
		getMeetingList,
		AddReply,
		getMeetingRecord
	} from '@/serve/meeting';
	import {
		getVoteCount,
		getVoteList,
		importGroupUser,
		importProgress,
		getGroupList,
		getGroupData,
		getMeetingFiles,
		getVideoList,
		uploadFiles,
		sortFiles,
		deleteFile,
		downloadFile,
		getVoteDetail,
		endVote,
		beginVote,
		getVoteGroupList,
		getVoteGroupCount,
		deleteVoteGroup,
		getMeetingFileCount,
		voteDetailReport,
		getGroupDetails,
		restartVote
	} from '@/serve/userGrouping';
	import axios from 'axios';
	export default {
		components: {
			AddVote,
			UploadFile,
			Progress,
			Pagination,
			VoteResult,
			SmsTemplate,
			VmsTemplate,
			Creditor,
			MeetingRecord,
			SMSManagement,
			VMSManagement,
			VoteResults
		},
		// props: {
		// 	meetingInfo: Object,

		// 	goIntoDialogVisible: Boolean,
		// 	isBtnShow: Boolean
		// },
		watch: {
			isFinish(newVal, oldVal) {
				if (newVal) {
					this.percentage = 100;
					clearTimeout(this.timer);
					this.$message.success('文件上传完毕');
					this.isShow = false;
					this.getGroupList();
				}
			},
			meetingId(newVal) {
				if (newVal) {
					this.getMeetingFiles();
				}
			},
			activeName(newVal, oldVal) {
				if (newVal !== 'four') {
					clearTimeout(this.timer);
					this.timer = null;
				} else if (newVal !== 'five') {
					this.isActiveName = '';
				} else if (newVal !== 'six') {
					this.isVmsActiveName = '';
				}
			}
		},
		computed: {
			...mapState({
				userInfo: (state) => state.user.userInfo
			}),
			// meetingId() {
			// 	return this.meetingData[0] && this.meetingData[0].id;
			// },
			actions() {
				return global.file.url;
			}
		},
		async created() {
			this.meetingName = "进入会议";
			this.meetingId = this.$route.query.id;
			this.previousTab = this.$route.query.tab;
			console.log("this.$route.query.name", this.$route.query);
			await this.ss();

		},
		beforeDestroy() {
			window.clearInterval(this.timer);
		},
		methods: {
			replyClose() {
				this.responseInput = '';
				this.meeting_id = '';
				this.id = '';
			},
			replyShow(meeting_id, id) {
				this.meeting_id = meeting_id;
				this.id = id;
				this.replyShowType = true;
			},
			async submitReply() {
				let meeting_id = this.meeting_id;
				let id = this.id;
				if (this.responseInput === '') {
					this.$message.warning('请输入回复内容');
					return;
				}
				await AddReply(meeting_id, {
						content: this.responseInput,
						pid: id
					}).then(() => {
						this.responseInput = '';
						this.replyShowType = false;
						this.meeting_id = '';
						this.id = '';
					})
					.catch(err => {
						this.$message.error(err.data.message);
					});
				// console.log("list:", list);
				// if (list.id != null) {
				// 	this.responseInput = '';
				// 	this.replyShowType = false;
				// 	this.meeting_id = '';
				// 	this.id = '';
				// }else{
				// 	this.$message.error(list.data.message);
				// }
			},
			async ss() {

				console.log("this.$route.query.id：", this.$route.query.id);
				this.meetingData = [await getMeetingDetail(this.$route.query.id)];
				this.meetingDataItem = this.meetingData[0];
				this.meetingInfo = this.meetingData[0];
				console.log("meetingData", this.meetingData);

			},
			onDownLoad(flowId) {
				meetingAuthGetFile(flowId).then(res => {
					window.open(res.fileUrl)
				})
			},
			tapShowDetails(row) {
				this.detailsVisible = true;
				this.form = {
					...row,
					meetingAuth: row.meetingAuth || {},
					agentMeetingAuth: row.agentMeetingAuth || {},
				}
			},
			signedInstrumentDownload() {
				let url =
					`/api/gathering/meeting_auth/download/files/${this.meetingId}` + '?access_token=' + this.token;
				console.log("url", url);
				this.export(url);
			},
			// 会议情况导出
			exportMeetingSituation() {
				let url =
					`/api/gathering/meeting/${this.meetingId}/invitee/list/export?test=` +
					this.userForm.test +
					'&name=' +
					this.userForm.name +
					'&username=' +
					this.userForm.username +
					'&attend=true' +
					'&sign=' +
					this.userForm.sign +
					'&page=0&rows=' +
					this.total +
					'&access_token=' +
					this.token;
				console.log("url", url);
				this.export(url);
			},
			// 表决人员详情导出
			exportVoteSituation() {
				let url =
					`/api/gathering/meeting/${this.meetingId}/invitee-group/list/export?group_id=` +
					this.voteDetailForm.group_id +
					'&name=' +
					this.voteDetailForm.name +
					'&username=' +
					this.voteDetailForm.username +
					'&test=' +
					this.voteDetailForm.test +
					'&phone=' +
					this.voteDetailForm.phone +
					'&sign=' +
					this.voteDetailForm.sign +
					'&page=0&rows=' +
					this.total +
					'&access_token=' +
					this.token;
				this.export(url);
			},
			// 问题列表导出
			exportQuestionSituation() {
				let url =
					`/api/gathering/meeting/${this.meetingId}/question/list/export?keyword=` +
					this.questionForm.keyword +
					'&mark=' +
					this.questionForm.mark +
					'&page=0&rows=' +
					this.total +
					'&access_token=' +
					this.token;
				this.export(url);
			},
			export (url) {
				const a = document.createElement('a');
				a.setAttribute('href', url);
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
			},
			// 翻页
			turnPage(attr, val) {
				this.voteDetailForm[attr] = val;
				this.getVoteGroupList();
			},
			filePage(attr, val) {
				this.fileForm[attr] = val;
				this.getMeetingFiles();
			},
			userPage(attr, val) {
				this.userForm[attr] = val;
				this.getCreatorUserList();
			},
			questionPage(attr, val) {
				this.questionForm[attr] = val;
				this.getQuestionList();
			},
			getStatus(row) {
				if (row.began) {
					if (row.ended) {
						return '已结束';
					} else {
						return '进行中';
					}
				} else {
					return '未开始';
				}
			},
			// 获取表决人员列表
			async getVoteGroupList() {
				this.loading = true;
				this.total = await getVoteGroupCount(this.meetingId, this.voteDetailForm);
				this.total > 0 ? this.getList() : ((this.meetingVoteData = []), (this.loading = false));
			},
			getList() {
				getVoteGroupList(this.meetingId, this.voteDetailForm)
					.then((res) => {
						for (let i = 0; i < res.length; i++) {
							res[i].serialNumber = i + 1;
							res[i].visible = false
						}
						this.meetingVoteData = this.handleTableList(res);
						this.loading = false;
					})
					.catch((err) => {
						this.$message.error(err.data.message);
						this.loading = false;
					});
			},
			// 获取参会人数情况
			getAttendSituation() {
				getAttendSituation(this.meetingId)
					.then((res) => {
						this.attendSituation = res;
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			// 获取会议情况人员列表
			async getCreatorUserList() {
				this.loading = true;
				this.getAttendSituation();
				console.log("meetingId:", this.meetingId);
				console.log("userForm:", this.userForm)
				this.total = await getCreatorCount(this.meetingId, this.userForm);
				if (this.total > 0) {
					getCreatorUserList(this.meetingId, this.userForm)
						.then((res) => {
							for (let i = 0; i < res.length; i++) {
								res[i].serialNumber = i + 1;
							}
							this.meetingVoteData = this.handleTableList(res);
							this.loading = false;
						})
						.catch((err) => {
							this.$message.error(err.data.message);
							this.loading = false;
						});
				} else {
					this.meetingVoteData = [];
					this.loading = false;
				}
			},
			// 问题标记
			markQuestion(row) {
				markQuestion(this.meetingId, row.id, {
						mark: !row.mark
					})
					.then(() => {
						this.$message.success('操作成功');
						this.getQuestionList();
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			// 问题标记分类
			markSign(e, event) {
				console.log("e:", e.name);
				if (e.name == 'second-first') {
					this.questionForm.mark = '';
				} else {
					this.questionForm.mark = true;
				}
				this.meetingVoteQuizData = [];
				this.total = 0;
				this.getQuestionList();
			},
			// 获取提问列表
			async getQuestionList() {
				this.total = await getQuestionCount(this.meetingId, this.questionForm);
				if (this.total > 0) {
					getQuestionList(this.meetingId, this.questionForm)
						.then((res) => {
							for (let i = 0; i < res.length; i++) {
								res[i].serialNumber = i + 1;
							}
							this.meetingVoteQuizData = this.handleTableList(res);
						})
						.catch((err) => {
							this.$message.error(err.data.message);
						});
				} else {
					this.meetingVoteQuizData = [];
				}
			},
			// 获取会议详情
			getMeetingDetail() {
				getMeetingDetail(this.meetingId)
					.then((res) => {
						this.question = res.question;
						this.getQuestionList();
						if (this.question) {
							this.pollingInterface();
						} else {
							this.timer && window.clearInterval(this.timer);
							// clearTimeout(this.timer);
							this.timer = null;
						}
					})
					.catch((err) => {
						this.$message.error(err.data.message);
						this.getQuestionList();
					});
			},
			// 定时调用提问列表
			pollingInterface() {
				this.timer = window.setInterval(() => {
					this.getQuestionList();
				}, 5000);
				// this.timer = setTimeout(() => {
				// 	this.getQuestionList();
				// 	this.pollingInterface();
				// }, 5000);
			},
			// 开启或结束提问
			changeQuestion() {
				if (this.question) {
					// 结束提问
					editQuestionStatus(this.meetingId, {
							open: false
						})
						.then(() => {
							this.$message.success('已结束提问');
							this.question = false;
							clearTimeout(this.timer);
							this.timer = null;
						})
						.catch((err) => {
							this.$message.error(err.data.message);
						});
				} else {
					// 开启提问
					editQuestionStatus(this.meetingId, {
							open: true
						})
						.then(() => {
							this.$message.success('已开启提问');
							this.getMeetingDetail();
						})
						.catch((err) => {
							this.$message.error(err.data.message);
						});
				}
			},
			// 开始或结束表决
			operationVote(sign, id) {
				if (sign === 'begin') {
					beginVote(id)
						.then(() => {
							this.$message.success('表决已开始');
							this.getVoteList();
						})
						.catch((err) => {
							this.$message.error(err.data.message);
						});
				} else {
					endVote(id)
						.then(() => {
							this.$message.success('表决已结束');
							this.getVoteList();
						})
						.catch((err) => {
							this.$message.error(err.data.message);
						});
				}
			},
			// 新建表决
			addVote() {
				this.getGroupData();
				this.voteDialogVisible = true;
				this.isEdit = false;
				this.isFlag = true;
				this.voteForm = {
					calculateRule: 1,
					allowPartVote: false,
					showProportion: false,
					allowWaive: false,
					denominator: 2,
					numerator: 1,
					options: [],
					voteType: 'SINGLE_CHOICE',
					groups: [],
					name: '',
					radio: '',
					content: '',
					subjectId: '', // 会议id
					enableRecommend: true,
					isReason: false,
					reasonWordNum: 0,
				};
			},
			//重开表决
			voteRestart(id) {
				this.$confirm('此操作将重新开启已结束的表决事项, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					customClass: 'del-model',
					type: 'warning'
				}).then(() => {
					restartVote(id)
						.then(() => {
							this.getVoteList();
							this.$message.success('开始表决成功');
						})
						.catch((err) => {
							this.$message.error(err.data.message);
						});
				});
			},
			// 四舍五入保留2位小数
			keepTwoDecimalFull(num) {
				let result = parseFloat(num);
				if (isNaN(result)) {
					return false;
				}
				result = Math.round(num * 100) / 100;
				let s_x = result.toString();
				let pos_decimal = s_x.indexOf('.');
				if (pos_decimal < 0) {
					pos_decimal = s_x.length;
					s_x += '.';
				}
				while (s_x.length <= pos_decimal + 2) {
					s_x += '0';
				}
				return s_x;
			},
			// 表决分组详情
			votingGroupingClick() {
				this.voteDetailLists = [];
				// this.voteDetail = row;
				this.voteResultDialogVisibles = true;
				this.voteLoadings = true;
				getGroupDetails(this.meetingId)
					.then((res) => {
						console.log("getGroupDetails", res);
						this.voteLoadings = false;
						// 表头设置
						res.forEach((item) => {
							item.isAddFlag = true;
							item.voteDetails = [];
							item.uckount = [];
							item.uckount1 = [];
							let obj1 = {};
							let obj2 = {};
							if (item.options == null || item.options == undefined || item.options == '') {
								item.options = [];
							}
							for (let i = 0; i < item.options.length; i++) {
								let citem = item.options[i];
								obj1['ak'] = ['债权人数'];
								obj2['ak'] = ['债权总额'];
								obj1['a' + i] = this.voteDetails.showProportion ? [citem.creditor, this
									.keepTwoDecimalFull(citem.creditorRate * 100) + '%'
								] : [citem.creditor];
								obj2['a' + i] = this.voteDetails.showProportion ? [citem.amount, this
									.keepTwoDecimalFull(citem.amountRate * 100) + '%'
								] : [citem.amount];
								if (item.isAddFlag) {
									item.uckount.push({
										name: 'ak',
										label: ''
									});
									item.isAddFlag = false;
								}
								item.uckount.push({
									name: 'a' + i,
									label: citem.itemName
								});
							}
							item.uckount1.push(obj1, obj2);
						});
						console.log("res:", res);
						console.log("this.voteDetails.voteType:", this.voteDetails.voteType);

						// 普通表决结果设置
						res.forEach((item) => {
							let temp1 = item.options.filter((citem) => citem.itemName === '同意');
							let temp2 = item.options.filter((citem) => citem.itemName === '反对');
							let temp3 = item.options.filter((citem) => citem.itemName === '弃权');


							console.log('jin');
							// let voteSignNoVote1 = [];
							// if(item.signedNoVote == null||item.signedNoVote == undefined || item.signedNoVote == ''){
							// 	item.signedNoVote = {
							// 		creditor:'',
							// 	}
							// }
							// if (this.voteDetails.showProportion && this.voteDetails.calculateRule === 1) {
							// 	voteSignNoVote1.push(item.signedNoVote.creditor);
							// 	let creditorRate1 = this.keepTwoDecimalFull(item.signedNoVote.creditorRate *
							// 		100)
							// 	if (creditorRate1 !== false) {
							// 		voteSignNoVote1.push(creditorRate1 + '%')
							// 	} else {
							// 		voteSignNoVote1.push('0.00%')
							// 	}
							// } else {
							// 	voteSignNoVote1.push(item.signedNoVote.creditor)
							// }
							// let agree1 = [];
							// if (!this.voteDetails.showProportion) {
							// 	agree1.push(temp1.length && temp1[0].creditor);
							// } else {

							// 	agree1.push(temp1.length && temp1[0].creditor);
							// 	let creditorRate2 = this.keepTwoDecimalFull(temp1.length && temp1[0]
							// 		.creditorRate * 100)

							// 	if (creditorRate2 != false) {
							// 		agree1.push(creditorRate2 + '%');
							// 	} else {
							// 		agree1.push('0.00%')
							// 	}
							// }
							// let opposition1 = [];
							// if (!this.voteDetails.showProportion) {
							// 	opposition1.push(temp2.length && temp2[0].creditor);
							// } else {
							// 	opposition1.push(temp2.length && temp2[0].creditor);
							// 	let creditorRate3 = this.keepTwoDecimalFull(temp2.length && temp2[0]
							// 		.creditorRate * 100)
							// 	if (creditorRate3 != false) {
							// 		opposition1.push(creditorRate3 + '%');
							// 	} else {
							// 		opposition1.push('0.00%')
							// 	}
							// }
							// let waiver1 = [];
							// if (!this.voteDetails.showProportion) {
							// 	waiver1.push(temp3.length && temp3[0].creditor);
							// } else {
							// 	waiver1.push(temp3.length && temp3[0].creditor);
							// 	let creditorRate4 = this.keepTwoDecimalFull(temp3.length && temp3[0]
							// 		.creditorRate * 100)
							// 	if (creditorRate4 != false) {
							// 		waiver1.push(creditorRate4 + '%');
							// 	} else {
							// 		waiver1.push('0.00%')
							// 	}
							// }
							// let voteSignNoVote2 = [];
							// if (this.voteDetails.showProportion && this.voteDetails.calculateRule === 1) {
							// 	voteSignNoVote2.push(item.signedNoVote.amount);
							// 	let amountRate1 = this.keepTwoDecimalFull(item.signedNoVote.amountRate * 100)
							// 	if (amountRate1 != false) {
							// 		voteSignNoVote2.push(amountRate1 + '%');
							// 	} else {
							// 		voteSignNoVote2.push('0.00%')
							// 	}
							// } else {
							// 	voteSignNoVote2.push(item.signedNoVote.amount);
							// }
							// let agree2 = [];
							// if (!this.voteDetails.showProportion) {
							// 	agree2.push(temp1.length && temp1[0].amount);
							// } else {
							// 	agree2.push(temp1.length && temp1[0].amount);
							// 	let amountRate2 = this.keepTwoDecimalFull(temp1.length && temp1[0].amountRate *
							// 		100)
							// 	if (amountRate2 != false) {
							// 		agree2.push(amountRate2 + '%');
							// 	} else {
							// 		agree2.push('0.00%')
							// 	}
							// }
							// let opposition2 = [];
							// if (!this.voteDetails.showProportion) {
							// 	opposition2.push(temp2.length && temp2[0].amount);
							// } else {
							// 	opposition2.push(temp2.length && temp2[0].amount);
							// 	let amountRate3 = this.keepTwoDecimalFull(temp2.length && temp2[0].amountRate *
							// 		100)
							// 	if (amountRate3 != false) {
							// 		opposition2.push(amountRate3 + '%');
							// 	} else {
							// 		opposition2.push('0.00%')
							// 	}
							// }
							// let waiver2 = [];
							// if (!this.voteDetails.showProportion) {
							// 	waiver2.push(temp3.length && temp3[0].amount);
							// } else {
							// 	waiver2.push(temp3.length && temp3[0].amount);
							// 	let amountRate4 = this.keepTwoDecimalFull(temp3.length && temp3[0].amountRate *
							// 		100)
							// 	if (amountRate4 != false) {
							// 		waiver2.push(amountRate4 + '%');
							// 	} else {
							// 		waiver2.push('0.00%')
							// 	}
							// }
							item.voteDetails.push({
								voteName: '债权人数',
								voteNums: item.whole.creditor,
								voteSigned: item.signed.creditor,
								// voted: item.voted.creditor,
								// voteSignNoVote: voteSignNoVote1,
								// agree: agree1,
								// opposition: opposition1,
								// waiver: waiver1

							}, {
								voteName: '债权总额',
								voteNums: item.whole.amount,
								voteSigned: item.signed.amount,
								// voted: item.voted.amount,
								// voteSignNoVote: voteSignNoVote2,
								// agree: agree2,
								// opposition: opposition2,
								// waiver: waiver2
							});			
						});
						this.voteDetailLists = res;
						console.log("voteDetailList:", this.voteDetailLists);
					})
			},
			// 表决结果
			VoteResult(row) {
				this.voteDetailList = [];
				this.voteDetail = row;
				this.voteResultDialogVisible = true;
				this.voteLoading = true;
				voteDetailReport(row.id)
					.then((res) => {
						this.voteLoading = false;
						//处理金额格式化
						res.map(item=>{						
							for (const key in item) {
								if (item[key] && typeof item[key] === 'object' && item[key]['amount'] !== undefined && item[key]['amount'] !== null) {
									item[key]['amount'] = this.$formatAmount(item[key]['amount']);
								}
								if(key == 'options'){
									item[key] = item[key].length && item[key].map(x=>{
										x['amount'] = this.$formatAmount(x['amount']);
										return x;
									});
								}
							}
						})
						// 表头设置
						res.forEach((item) => {
							item.isAddFlag = true;
							item.voteDetails = [];
							item.uckount = [];
							item.uckount1 = [];
							let obj1 = {};
							let obj2 = {};
							for (let i = 0; i < item.options.length; i++) {
								let citem = item.options[i];
								obj1['ak'] = ['债权人数'];
								obj2['ak'] = ['债权总额'];
								obj1['a' + i] = this.voteDetail.showProportion ? [citem.creditor, this
									.keepTwoDecimalFull(citem.creditorRate * 100) + '%'
								] : [citem.creditor];
								obj2['a' + i] = this.voteDetail.showProportion ? [citem.amount, this
									.keepTwoDecimalFull(citem.amountRate * 100) + '%'
								] : [citem.amount];
								if (item.isAddFlag) {
									item.uckount.push({
										name: 'ak',
										label: ''
									});
									item.isAddFlag = false;
								}
								item.uckount.push({
									name: 'a' + i,
									label: citem.itemName
								});
							}
							item.uckount1.push(obj1, obj2);
						});
						console.log("res:", res);
						// if(this.voteDetail.voteType === 'SINGLE_CHOICE'){
						// 普通表决结果设置
						res.forEach((item) => {
							let temp1 = item.options.filter((citem) => citem.itemName === '同意');
							let temp2 = item.options.filter((citem) => citem.itemName === '反对');
							let temp3 = item.options.filter((citem) => citem.itemName === '弃权');
							console.log("this.voteDetail.showProportion:", this.voteDetail.showProportion &&
								this.voteDetail.calculateRule === 1);
							let voteSignNoVote1 = [];
							if (this.voteDetail.showProportion && this.voteDetail.calculateRule === 1) {
								voteSignNoVote1.push(item.signedNoVote.creditor);
								let creditorRate1 = this.keepTwoDecimalFull(item.signedNoVote.creditorRate *
									100)
								if (creditorRate1 !== false) {
									voteSignNoVote1.push(creditorRate1 + '%')
								} else {
									voteSignNoVote1.push('0.00%')
								}
							} else {
								voteSignNoVote1.push(item.signedNoVote.creditor)
							}
							let agree1 = [];
							if (!this.voteDetail.showProportion) {
								agree1.push(temp1.length && temp1[0].creditor);
							} else {

								agree1.push(temp1.length && temp1[0].creditor);
								let creditorRate2 = this.keepTwoDecimalFull(temp1.length && temp1[0]
									.creditorRate * 100)

								if (creditorRate2 != false) {
									agree1.push(creditorRate2 + '%');
								} else {
									agree1.push('0.00%')
								}
							}
							let opposition1 = [];
							if (!this.voteDetail.showProportion) {
								opposition1.push(temp2.length && temp2[0].creditor);
							} else {
								opposition1.push(temp2.length && temp2[0].creditor);
								let creditorRate3 = this.keepTwoDecimalFull(temp2.length && temp2[0]
									.creditorRate * 100)
								if (creditorRate3 != false) {
									opposition1.push(creditorRate3 + '%');
								} else {
									opposition1.push('0.00%')
								}
							}
							let waiver1 = [];
							if (!this.voteDetail.showProportion) {
								waiver1.push(temp3.length && temp3[0].creditor);
							} else {
								waiver1.push(temp3.length && temp3[0].creditor);
								let creditorRate4 = this.keepTwoDecimalFull(temp3.length && temp3[0]
									.creditorRate * 100)
								if (creditorRate4 != false) {
									waiver1.push(creditorRate4 + '%');
								} else {
									waiver1.push('0.00%')
								}
							}
							let voteSignNoVote2 = [];
							if (this.voteDetail.showProportion && this.voteDetail.calculateRule === 1) {
								voteSignNoVote2.push(item.signedNoVote.amount);
								let amountRate1 = this.keepTwoDecimalFull(item.signedNoVote.amountRate * 100)
								if (amountRate1 != false) {
									voteSignNoVote2.push(amountRate1 + '%');
								} else {
									voteSignNoVote2.push('0.00%')
								}
							} else {
								voteSignNoVote2.push(item.signedNoVote.amount);
							}
							let agree2 = [];
							if (!this.voteDetail.showProportion) {
								agree2.push(temp1.length && temp1[0].amount);
							} else {
								agree2.push(temp1.length && temp1[0].amount);
								let amountRate2 = this.keepTwoDecimalFull(temp1.length && temp1[0].amountRate *
									100)
								if (amountRate2 != false) {
									agree2.push(amountRate2 + '%');
								} else {
									agree2.push('0.00%')
								}
							}
							let opposition2 = [];
							if (!this.voteDetail.showProportion) {
								opposition2.push(temp2.length && temp2[0].amount);
							} else {
								opposition2.push(temp2.length && temp2[0].amount);
								let amountRate3 = this.keepTwoDecimalFull(temp2.length && temp2[0].amountRate *
									100)
								if (amountRate3 != false) {
									opposition2.push(amountRate3 + '%');
								} else {
									opposition2.push('0.00%')
								}
							}
							let waiver2 = [];
							if (!this.voteDetail.showProportion) {
								waiver2.push(temp3.length && temp3[0].amount);
							} else {
								waiver2.push(temp3.length && temp3[0].amount);
								let amountRate4 = this.keepTwoDecimalFull(temp3.length && temp3[0].amountRate *
									100)
								if (amountRate4 != false) {
									waiver2.push(amountRate4 + '%');
								} else {
									waiver2.push('0.00%')
								}
							}
							item.voteDetails.push({
								voteName: '债权人数',
								voteNums: item.whole.creditor,
								voteSigned: item.signed.creditor,
								voted: item.voted.creditor,
								voteSignNoVote: voteSignNoVote1,
								agree: agree1,
								opposition: opposition1,
								waiver: waiver1

							}, {
								voteName: '债权总额',
								voteNums: item.whole.amount,
								voteSigned: item.signed.amount,
								voted: item.voted.amount,
								voteSignNoVote: voteSignNoVote2,
								agree: agree2,
								opposition: opposition2,
								waiver: waiver2
							});
						});
						// }
						
						this.voteDetailList = res;
						console.log("=========voteDetailList>>>", this.voteDetailList);
					})
					.catch((err) => {
						this.voteLoading = false;
						// this.$message.error(err.data.message);
					});
			},
			// 编辑表决
			async editVote(row, flag = true) {
				this.voteDialogVisible = true;
				this.isEdit = true;
				this.isFlag = flag;
				await getVoteDetail(row.id)
					.then((res) => {
						if (res.voteType === 'SINGLE_CHOICE') {
							res.groups = res.groups.map((item) => item.groupId);
							res.options = [];
						} else if (res.voteType === 'MULTIPLE_CHOICE') {
							res.radio = res.groups[0].groupId;
							res.options = res.options.map((item) => item.name);
							res.groups = res.groups.map((item) => item.groupId);
							if (res.options.includes('弃权')) {
								let index = res.options.indexOf('弃权');
								res.options.splice(index, 1);
							}
						} else if (res.voteType === 'ELECT') {
							let list = [];
							for (let i in res.options) {
								if (res.options[i].isShow) {
									list.push({
										name: res.options[i].name,
										userId: res.options[i].userId
									})
								}
							}
							res.options = list;
							let lists = [];
							res.groups = res.groups.map((item) => item.groupId);
						}
						console.log("res", res)
						this.voteForm = res;
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			// 下载文件
			downloadFile(id, name) {
				// const href = `https://api.pochanyun.com/api/sys/fs/${id}?d=1`;
				// const href = `https://live.pochanyun.net/api/sys/fs/${id}`;
				const href = `/api/sys/fs/${id}?d=1`;
				const a = document.createElement('a');
				a.setAttribute('href', href);
				a.setAttribute('download', name);
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
			},
			// 编辑排序
			editSort(row) {
				this.sortDialogVisible = true;
				this.sortOrd = row.ord;
				this.fileId = row.id;
			},
			// 排序上升/下降
			sort(scope, type) {
				let params = [];
				if (type === 'up') {
					if (scope.$index === 0) {
						return this.$message.warning('当前项不能上升');
					}
					if (
						scope.row.ord === this.meetingVoteData[scope.$index - 1].ord ||
						(scope.row.ord == 0 && this.meetingVoteData[scope.$index - 1].ord == 0)
					) {
						return this.$message.error('请修改当前项的排序值');
					}
					params.push({
						id: this.meetingVoteData[scope.$index - 1].id,
						ord: scope.row.ord
					}, {
						id: scope.row.id,
						ord: this.meetingVoteData[scope.$index - 1].ord
					});
				} else {
					if (scope.$index === this.meetingVoteData.length - 1) {
						return this.$message.warning('当前项不能下降');
					}
					if (
						scope.row.ord === this.meetingVoteData[scope.$index + 1].ord ||
						(scope.row.ord == 0 && this.meetingVoteData[scope.$index + 1].ord == 0)
					) {
						return this.$message.error('请修改当前项的排序值');
					}
					params.push({
						id: this.meetingVoteData[scope.$index + 1].id,
						ord: scope.row.ord
					}, {
						id: scope.row.id,
						ord: this.meetingVoteData[scope.$index + 1].ord
					});
				}
				sortFiles(this.meetingId, params)
					.then(() => {
						this.sortDialogVisible = false;
						this.$message.success(type === 'up' ? '上升成功' : '下降成功');
						this.getMeetingFiles();
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			// 确定排序
			sureSort() {
				if (!this.sortOrd) {
					return this.$message.error('请输入数字');
				}
				sortFiles(this.meetingId, [{
						id: this.fileId,
						ord: +this.sortOrd
					}])
					.then(() => {
						this.sortDialogVisible = false;
						this.$message.success('排序成功');
						this.getMeetingFiles();
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			// tab切换
			handleClick(tab) {
				this.meetingVoteData = [];
				console.log("tab.name", tab.name)
				this.tagQuestion = 'second-first';
				this.questionForm.mark = '';
				if (tab.name != 'four') {
					this.timer && window.clearInterval(this.timer);
					// clearTimeout(this.timer);
					this.timer = null;
				} else if (this.question && tab.name == 'four') {
					// this.pollingInterface();
				}
				switch (tab.name) {
					case 'first':
						this.peopleManagementActiveName = 'first';
						this.getMeetingFiles();
						break;
					case 'second':
						this.peopleManagementActiveName = 'second';
						this.subActiveName = 'second-first';
						this.getVoteList();
						this.getGroupData();
						break;
					case 'third':
						this.peopleManagementActiveName = 'third';
						this.getCreatorUserList();
						break;
					case 'four':
						// 提问列表
						this.peopleManagementActiveName = 'four';
						this.tagQuestion = 'second-first';
						this.getMeetingDetail();
						break;
					case 'five':
						this.peopleManagementActiveName = 'five';
						this.isActiveName = 'first';
						this.getSmsTemplate();
						this.getGroupList();
						break;
					case 'peopleManagement':
						this.peopleManagementActiveName = 'peopleManagement';
						if(this.userInfo.type == 'MANAGER'){
							this.creditorActiveName = 'second';
						}else{
							this.creditorActiveName = 'first';
						}
						// this.getSmsTemplate();
						break;
					case 'meetingRecord':
						this.peopleManagementActiveName = 'meetingRecord';
						this.getMeetingRecord();
						break;
					default:
						this.peopleManagementActiveName = 'first';
						this.isVmsActiveName = 'first';
						this.getVmsTemplate();
						break;
				}
			},
			getMeetingRecord() {
				console.log("res", this.meetingId);
				this.getMeetingRecordRes = {};
				getMeetingRecord(this.meetingId)
					.then((res) => {
						console.log("res:", res);
						this.getMeetingRecordRes = res;
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			// 表决管理tab切换
			handleSubClick(tab) {
				this.meetingVoteData = [];
				switch (tab.name) {
					case 'second-first':
						this.getVoteList();
						break;
					case 'second-second':
						this.getGroupList();
						break;
					default:
						this.getGroupData();
						this.getVoteGroupList();
						break;
				}
			},
			// 文件列表切换
			handleFileClick(tab) {
				this.fileActiveName = tab.name;
				this.getMeetingFiles();
			},
			// 上传会议文档
			uploadMeetingFile(flag) {
				if (flag === 'video') {
					this.isVideo = true;
				} else {
					this.isVideo = false;
				}
				this.uploadDialogVisible = true;
				this.isAccept = true;
			},
			// 删除会议文档
			deleteFile(id) {
				deleteFile(this.meetingId, id)
					.then(() => {
						this.$message.success('删除成功');
						this.getMeetingFiles();
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			// 获取会议文档列表
			async getMeetingFiles() {
				this.loading = true;
				if (this.fileActiveName === 'first') {
					this.total = await getMeetingFileCount(this.meetingId, {
						excludeVideo: true
					});
					if (this.total > 0) {
						getMeetingFiles(this.meetingId, this.fileForm)
							.then((res) => {
								this.meetingVoteData = this.handleTableList(res);
								console.log("meetingVoteData", this.meetingVoteData);
								this.loading = false;
							})
							.catch((err) => {
								this.$message.error(err.data.message);
								this.loading = false;
							});
					} else {
						this.meetingVoteData = [];
						this.loading = false;
					}
				} else {
					this.meetingVoteData = [];
					getVideoList(this.meetingId)
						.then((res) => {
							this.meetingVoteData = this.handleTableList(res);
							this.total = this.meetingVoteData.length;
							this.loading = false;
						})
						.catch((err) => {
							this.$message.error(err.data.message);
							this.loading = false;
						});
				}
			},
			voteListPage(attr, val) {
				this.voteListForm[attr] = val;
				this.getVoteList();
			},
			// 获取表决事项列表
			async getVoteList() {
				this.loading = true;
				this.voteListForm.meeting_id = this.meetingId;
				this.total = await getVoteCount({
					meeting_id: this.meetingId
				});
				if (this.total > 0) {
					getVoteList(this.voteListForm)
						.then((res) => {
							for (let i = 0; i < res.length; i++) {
								res[i].serialNumber = i + 1;
							}
							this.meetingVoteData = this.handleTableList(res);
							this.loading = false;
						})
						.catch((err) => {
							this.$message.error(err.data.message);
							this.loading = false;
						});
				} else {
					this.meetingVoteData = [];
					this.loading = false;
				}
			},
			// 获取分组组别
			getGroupData() {
				getGroupData(this.meetingId)
					.then((res) => {
						this.groupData = res;
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			// 获取表决分组列表
			getGroupList() {
				this.loading = true;
				getGroupList(this.meetingId)
					.then((res) => {
						for (let i = 0; i < res.length; i++) {
							res[i].serialNumber = i + 1;
						}
						console.log("分组：", res)
						this.meetingVoteDatas = this.handleTableList(res);
						this.loading = false;
						this.percentage = 0;
					})
					.catch((err) => {
						this.loading = false;
						this.$message.error(err.data.message);
					});
			},
			//删除表决分组
			deleteGroup(groupId) {
				// console.log('111');
				deleteVoteGroup(this.meetingId, groupId)
					.then(() => {
						this.$message.success('删除成功');
						this.getGroupList();
						this.getGroupData();
						this.getVoteGroupList();
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			cancelVisible() {
				this.activeName = 'first';
				this.isActiveName = '';
				this.isVmsActiveName = '';
				this.peopleManagementActiveName = '';
				this.$emit('cancel', 'goIntoDialogVisible');
			},
			// 搜索
			onSearch(flag) {
				if (this[flag].sign === '0') {
					this[flag].sign = '';
				}
				if (this[flag].test === '0') {
					this[flag].test = '';
				}
				this[flag].page = 0;
				this[flag].rows = 20;
				flag === 'voteDetailForm' ?
					this.getVoteGroupList() :
					flag === 'questionForm' ?
					this.getQuestionList() :
					this.getCreatorUserList();
			},
			timeFormat(timescape) {
				return moment(timescape).format('YYYY-MM-DD HH:mm:ss');
			},
			cancels() {
				this.voteForms = {
					calculateRule: 0,
					allowPartVote: false,
					showProportion: false,
					allowWaive: false,
					denominator: 2,
					numerator: 1,
					options: [],
					voteType: 'SINGLE_CHOICE',
					groups: [],
					name: '',
					radio: '',
					content: '',
					subjectId: '' // 会议id
				};
				this.voteDialogVisibles = false;
				this.uploadDialogVisibles = false;
				this.voteResultDialogVisibles = false;
			},
			cancel() {
				this.voteForm = {
					calculateRule: 0,
					allowPartVote: false,
					showProportion: false,
					allowWaive: false,
					denominator: 2,
					numerator: 1,
					options: [],
					voteType: 'SINGLE_CHOICE',
					groups: [],
					name: '',
					radio: '',
					content: '',
					subjectId: '' // 会议id
				};
				this.voteDialogVisible = false;
				this.uploadDialogVisible = false;
				this.voteResultDialogVisible = false;
			},
			// 确认上传
			sureUpload(id, name, format) {
				const now = Date.now();
				if (this.lastSureUploadTime && now - this.lastSureUploadTime < 1000) {
					return;
				}
				if (this.isFileUploading) {
					return;
				}
				this.lastSureUploadTime = now;
				this.isFileUploading = true;
				const finishUpload = () => {
					this.isFileUploading = false;
				};
				bus.$emit('clear');
				this.uploadDialogVisible = false;
				if (this.isAccept || this.isVideo) {
					let ord = 0;
					if (this.meetingVoteData.length > 0) {
						this.meetingVoteData.forEach((item) => {
							ord = ord < item.ord ? item.ord : ord;
						});
					}
					ord++;
					uploadFiles(this.meetingId, {
							docId: id,
							ord: ord,
							type: format,
							name
						})
						.then(() => {
							this.$message.success('文件上传成功');
							if (this.isVideo) {
								this.fileActiveName = 'second';
							}
							this.getMeetingFiles();
						})
						.catch((err) => {
							this.$message.error(err.data.message);
						})
						.finally(finishUpload);
				} else {
					this.isShow = true;
					importGroupUser(this.meetingId, {
							fileId: id
						})
						.then((res) => {
							this.progressId = res.id;
							this.fileProgressUpload(this.progressId);
						})
						.catch((err) => {
							this.$message.error(err.data.message);
						})
						.finally(finishUpload);
				}
			},
			// 文件进度接口
			fileProgressUpload(id) {
				importProgress(this.meetingId, id)
					.then((res) => {
						console.log("res:", res)
						if (!res.success) {
							if (res.failedList.length != '0') {
								this.$message.error(`${res.failedList.toString()},${res.errMessage}`);
							} else {
								this.$message.error(`${res.errMessage}`);
							}
							clearTimeout(this.timer);
							this.timer = null;
							this.isShow = false;
						} else {
							this.fileCount = res.count;
							this.isFinish = res.finished;
							if (res.total) {
								this.percentage = parseInt((100 * this.fileCount) / res.total);
							}
							this.timer = setTimeout(() => {
								this.fileProgressUpload(this.progressId);
							}, 500);
						}

					})
					.catch((err) => {
						console.log('err', err);
						this.isShow = false;
						if (err.status === 400) {
							this.importDialogVisible = true;
							this.person = [...new Set(err.data.data)].join(',');
						}
					});
			},
			// 获取短信模板内容
			getSmsTemplate() {
				getSmsTemplate(this.meetingId)
					.then((res) => {
						this.smsTemplateList = res.filter((item) => item.code != 'SMS_CHANGE_PASSWORD');
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			getVmsTemplate() {
				getVmsTemplate(this.meetingId)
					.then((res) => {
						this.vmsTemplateList = res.filter((item) => item.code != 'VMS_CHANGE_PASSWORD');
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			goBack() {
				this.$router.push({
					path: '/meetingManages',
					query: {
						tab: this.previousTab,
					}
				});
			},
		},
		data() {
			return {
				creditorActiveName: '',
				getMeetingRecordRes: {},
				meeting_id: '',
				id: '',
				replyShowType: false,
				responseInput: '',
				form: {
					meetingAuth: {},
					agentMeetingAuth: {},
				},
				meetingData: [],
				meetingDatas: [],
				meetingDataItem: {
					subject: '',
					name: '',
					startTime: ''
				},
				meetingName: '',
				meetingId: '',
				meetingInfo: Object,
				goIntoDialogVisible: Boolean,
				isBtnShow: Boolean,
				detailsVisible: false,
				token: sessionStorage.getItem('ms_token'),
				attendSituation: {},
				isFlag: false,
				voteDetail: {},
				voteDetails: {},
				person: [],
				fileId: '',
				sortOrd: '',
				isActiveName: '',
				peopleManagementActiveName: '',
				isVmsActiveName: '',
				loading: false,
				isFileCheck: false,
				isAccept: false,
				isVideo: false,
				total: 0,
				percentage: 0,
				question: false, // 是否开启提问
				tagQuestion: 'second-firsts',
				progressId: '',
				isEdit: false,
				isShow: false,
				fileCount: -1,
				timer: null,
				isFinish: false,
				activeName: 'first',
				subActiveName: 'second-first',
				fileActiveName: 'first',
				voteDialogVisible: false,
				uploadDialogVisible: false,
				isFileUploading: false,
				lastSureUploadTime: 0,
				sortDialogVisible: false,
				importDialogVisible: false,
				voteResultDialogVisible: false,
				voteResultDialogVisibles: false,
				meetingVoteDatas: [],
				meetingVoteData: [],
				meetingVoteQuizData: [],
				voteDetailList: [],
				voteDetailLists: [],
				smsTemplateList: [],
				vmsTemplateList: [],
				voteLoading: false,
				voteLoadings: false,
				groupData: [], // 分组组别
				voteDetailForm: {
					group_id: '',
					name: '',
					page: 0,
					rows: 20,
					phone: '',
					sign: '',
					test: '',
					username: ''
				},
				fileForm: {
					excludeVideo: true,
					meeting_id: '',
					page: 0,
					rows: 20
				},
				userForm: {
					name: '',
					username: '',
					attend: true,
					sign: '',
					test: '',
					page: 0,
					rows: 20
				},
				questionForm: {
					keyword: '',
					mark: '',
					page: 0,
					rows: 20
				},
				voteListForm: {
					page: 0,
					rows: 20
				},
				voteForm: {
					calculateRule: 0,
					allowPartVote: false,
					showProportion: false,
					allowWaive: false,
					enableRecommend: false,
					denominator: 2,
					numerator: 1,
					options: [],
					voteType: 'SINGLE_CHOICE',
					groups: [],
					name: '',
					radio: '',
					content: '',
					subjectId: '' // 会议id
				}
			};
		}
	};
</script>
<style scoped lang="scss">
	::v-deep .el-table__fixed-right::before,
	::v-deep .el-table__fixed::before {
		height: 0px !important;
	}

	::v-deep .votestaff-search .el-input--small .el-input__inner {
		background-color: #F3F4F6;
		border: 0px;
		border-radius: 3px;
	}

	::v-deep .el-tabs__nav-scroll {
		padding-left: 0px !important;
		box-sizing: border-box;
	}

	::v-deep .meeting-search .el-input__inner {
		background-color: #F3F4F6;
		border: 0px;
		border-radius: 3px;
		width: 100%;
	}

	.details_name {
		font-size: 14px;
		font-family: Source Han Sans CN-Medium, Source Han Sans CN;
		font-weight: 500;
		color: #74798C;
		line-height: 22px;
		width: 100px;
		text-align: right;
	}

	.details_content {
		font-size: 24px;
		font-family: Source Han Sans CN-Medium, Source Han Sans CN;
		font-weight: 500;
		color: #282D30;
		line-height: 28px;
		margin-left: 20px;
	}

	.details_content_1 {
		font-size: 14px;
		font-family: Source Han Sans CN-Regular, Source Han Sans CN;
		font-weight: 400;
		color: #282D30;
		line-height: 22px;
		margin-left: 20px;
	}

	.wrapper {
		height: auto;

		.pagination {
			.el-pagination {
				padding: 2px 15px;
			}
		}

		.el-page-header {
			background: #fff;
			padding: 15px;
		}
	}

	.top_title {
		font-size: 14px;
		font-family: Source Han Sans CN-Regular, Source Han Sans CN;
		font-weight: 400;
		color: #74798C;
		line-height: 20px;
	}

	.top_content {
		font-size: 18px;
		font-family: Source Han Sans CN-Regular, Source Han Sans CN;
		font-weight: 400;
		color: #282D30;
		line-height: 26px;
	}

	.enterMeeting {
		::v-deep .el-dialog__body {
			padding: 0;
		}

		.el-table {
			::v-deep .is-leaf {
				// background: #e6e6e6 !important;

				text-align: center;
				color: #000;
			}

			::v-deep .el-table__row {
				::v-deep .cell {
					text-align: center;
					// display: -webkit-box;
					// -webkit-line-clamp: 10;
					// overflow: hidden;
					// text-overflow: ellipsis;
					// -webkit-box-orient: vertical;
				}
			}
		}

		.meeting-document {
			::v-deep .el-tabs__content {
				padding: 0;
			}

			.votestaff-search {
				text-align: left;
				padding-left: 2%;
			}

			.meeting-search {
				width: 100%;
				background: #FFFFFF;
				padding-top: 20px;
				padding-left: 2%;
				box-sizing: border-box;

				.situation {
					display: flex;
					justify-content: flex-start;
					align-items: center;
					margin-bottom: 10px;

					p {
						margin-right: 10px;
					}
				}

				.meeting-search-button {
					margin-left: 15px;
				}

				.meeting-test-number {
					padding-bottom: 15px;
				}
			}

			.el-table ::v-deep .is-leaf {
				// background: #f17b2e !important;
				//  background: -webkit-linear-gradient(top, #cc0001 , #de4d2a, #f17b2e) !important;
				// background: -webkit-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%) !important;
				// background: -moz-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%) !important;
				// background: -o-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%) !important;
				// background: -ms-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%) !important;
				// background: linear-gradient(180deg, #cc0001 0%, #f17b2e 100%) !important;
				background: #fafbfd;
				color: rgba(25, 30, 36, 0.6);

				// color: #fff;
			}

			.operation {
				color: #2c7bbc;
				font-size: 16px;
			}

			.operation ::v-deep span:hover {
				border-bottom: 1px solid #2c7bbc;
			}

			.tag-question {
				padding: 10px 20px 0 20px;

			}

			.mark-question {
				color: #2c7bbc;

				::v-deep span:hover {
					border-bottom: 1px solid #2c7bbc;
				}
			}

			.question-card {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 10px 20px;

				&>div:nth-child(1) {
					flex: 1;
					display: flex;

					.el-button {
						margin-left: 2%;
					}
				}

				&>div:nth-child(2) {
					flex: 1;
					text-align: right;
				}
			}

			.voting-managent {
				text-align: right;

				::v-deep .el-tabs__nav-scroll {
					padding-left: 15px;
				}

				.importFile {
					display: flex;
					justify-content: space-between;
					align-items: center;
				}

				.import {
					margin: 0 10px 10px 0;
				}
			}

			.meeting-header-download {
				width: 100%;
				height: 35px;
				line-height: 35px;
				background: #f5f5f5;
				text-align: right;
				color: #988f8f;
				font-size: 13px;

				a {
					text-decoration: underline;

					&:hover {
						color: #c22929;
						cursor: pointer;
					}
				}
			}
		}
	}
</style>